<template>
  <div class="main-header-left">
    <div class="breadcrumbs">
      <CarReturnLink
          :oldCars="true"
          :companyId="car.company.id"
          :total="carTotal"/>

      <div
          v-if="visibleBreadCrumbs1560"
          :class="classPreloader"
          @click="routerPush(companyUrl)">

        {{ car.company.name }}
      </div>

      <div
          v-show="visibleBreadCrumbs1439"
          v-for="(body, i) in categoriesBodies"
          :key="body.id"
          :class="[classPreloader, {'comma': i != categoriesBodies.length - 1}]"
          @click="routerPush(setUrlParams({
            flokkar: [body.id],
          }))">

        {{ body.name }}
      </div>

      <div
          :class="classPreloader"
          @click="routerPush(brandUrl)">

        {{ brandName }}
      </div>

      <div
          :class="classPreloader"
          @click="routerPush(brandModelUrl)">

        {{ modelName }}
      </div>

      <div
          v-show="!$device.mobile() && !$device.tablet()"
          :class="classPreloader"
          @click="routerPush(yearUrl)">
        {{ car.argerd }}
      </div>
    </div>

    <span v-show="!$device.mobile() && !$device.tablet()" class="main-header-serial-number">
      Raðnúmer:
      <b class="ml">{{ carId }}</b>
    </span>
  </div>
</template>

<script>
import globalNewCar from "@/helpers/globalNewCar";
import {mapState, mapGetters, mapMutations} from 'vuex';

import CarReturnLink from "@/components/Dealers/CarReturnLink";
import routesNames from '@/router/constants'

export default {
  props: {
    car: {
      type: Object,
      require: true
    },
    loaded: Boolean
  },
  components: {
    CarReturnLink,
  },
   methods: {
    ...mapMutations({
      setData: "SET_DATA",
    }),
    routerPush(link) {
      this.setData({
        field: "moduleOldCars.cars.items",
        data: []
      });
      this.setData({
        field: "moduleOldCars.cars.loaded",
        data: false
      });
      this.$router.push(link);
    },
    resetScrollTop() {
      this.$store.state.scrollPositionPageDealers = 0;
    },
     //test 2
    setUrlParams(objectParams) {
      if(this.$route.name == 'k7Car'){
        return `/k7/${globalNewCar.setUrlParams(objectParams)}`
      }
      return `${routesNames.oldCars}/${globalNewCar.setUrlParams(objectParams)}`
    }
  },
  computed: {
    ...mapState({
      screenWidth: state => state.screen.width
    }),
    ...mapGetters({
      lib: 'LIB'
    }),

    visibleBreadCrumbs1439() {
      return this.screenWidth > 1439
    },

    visibleBreadCrumbs1560() {
      return this.screenWidth > 1560
    },

    categoriesBodies() {
      return this.lib && this.lib.flokkar ? this.lib.flokkar.filter(body => this.car.categories.some(category => body.id == category)) : []
    },

    carTotal() {
      return this.screenWidth > 560
        ? this.car.total
        : null
    },

    carId() {
      return this.car.api_id;
    },

    companyUrl() {
      return (
          this.car.company &&
          this.setUrlParams({
            companies: [this.car.company.id],
          })
      );
    },

    categoryUrl() {
      return this.setUrlParams({
        flokkar: [this.car.flokkur_id],
      })
    },

    brandUrl() {
      return this.setUrlParams({
        brands: [this.car.brand_id],
      })
    },

    brandModelUrl() {
      return this.setUrlParams({
        brand_model: [this.car.model_id],
        brands: [this.car.brand_id],
      })
    },

    yearUrl() {
      const year = parseInt(this.car.argerd);
      return this.setUrlParams({
        argerd: [year, year],
      })
    },

    brandName() {
      return this.car.ext_modframleidandi
    },

    modelName() {
      return this.car.ext_modgerd ? this.car.ext_modgerd.split(" ")[0] : ""
    },

    classPreloader() {
      return 'breadcrumbs-item ' + (!this.loaded
          ? 'b-empty shine-short'
          : 'cursor-pointer')
    }
  },
};
</script>
